<template>
  <el-row type="flex" justify="center" align="middle" :style="`min-height:${height}`">
    <slot></slot>
  </el-row>
</template>

<script>
export default {
  props: {
    height: {
      default: "10vh"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>